import React, { useState, useEffect } from 'react';
import {
  SWITCH_VIEW_MODE,
  TWO_D_TYPE,
  THREE_D_TYPE,
  VISUALIZE_TYPE
} from '../../utilities/constants/Constants';
import './DimensionTemplate.scss';
import { Icons } from '../../utilities';
import MediaQuery from 'react-responsive';

const dimensionTemplate = props => {
  const {
    clickHandler,
    sidebarIsHiddenInDesktop,
    isSticker,
    isCanvas,
    viewType
  } = props;

  const defaultActiveButtonId =
    viewType === TWO_D_TYPE || viewType === VISUALIZE_TYPE
      ? SWITCH_VIEW_MODE.SECOND_OPTION
      : SWITCH_VIEW_MODE.FIRST_OPTION;

  const [activeButtonId, setActiveButtonId] = useState(defaultActiveButtonId);

  useEffect(() => {
    setActiveButtonId(defaultActiveButtonId);
  }, [defaultActiveButtonId]);

  const toggleButton = () => {
    if (activeButtonId == SWITCH_VIEW_MODE.FIRST_OPTION) {
      buttonIsClicked(SWITCH_VIEW_MODE.SECOND_OPTION);
    } else {
      buttonIsClicked(SWITCH_VIEW_MODE.FIRST_OPTION);
    }
  };

  const buttonIsClicked = buttonId => {
    setActiveButtonId(buttonId);
    clickHandler(buttonId);
  };

  const getSelectionOrNormalClass = buttonId => {
    if (activeButtonId === buttonId) {
      return 'dimension-button dimension-button-focused';
    }
    return 'dimension-button';
  };

  const getIcon = buttonId => {
    if (buttonId == SWITCH_VIEW_MODE.FIRST_OPTION) {
      if (isSticker) {
        return Icons.sticker_edit_icon;
      }
      if (isCanvas) {
        return Icons.zoom_out;
      }
    }
    if (buttonId == SWITCH_VIEW_MODE.SECOND_OPTION) {
      if (isSticker) {
        return Icons.sticker_visualize_icon;
      }
      if (isCanvas) {
        return Icons.zoom_in;
      }
    }
    return null;
  };

  const getMobileViewIcon = () => {
    if (activeButtonId == SWITCH_VIEW_MODE.FIRST_OPTION) {
      if (isCanvas) {
        return Icons.zoom_out_selected;
      }
      return Icons.threeD_icon_selected;
    }
    if (isCanvas) {
      return Icons.zoom_out_disabled;
    }
    return Icons.threeD_icon_disabled;
  };

  return (
    <div
      className={[
        'dimension-container',
        sidebarIsHiddenInDesktop ? 'dimension-button-position' : null
      ].join(' ')}
      id='help-dimension-template'
    >
      <MediaQuery query='(max-width: 767px)'>
        <button
          type='button'
          style={{ outline: 'none' }}
          className='dimension-toggle-button'
          onClick={toggleButton}
        >
          <img
            src={getMobileViewIcon()}
            alt='3D-icon'
            style={{ width: '24px', height: '24px' }}
          />
        </button>
      </MediaQuery>
      <MediaQuery query='(min-width: 767px)'>
        <button
          type='button'
          className={getSelectionOrNormalClass(SWITCH_VIEW_MODE.FIRST_OPTION)}
          onClick={() => buttonIsClicked(SWITCH_VIEW_MODE.FIRST_OPTION)}
        >
          {getIcon(SWITCH_VIEW_MODE.FIRST_OPTION) ? (
            <img src={getIcon(SWITCH_VIEW_MODE.FIRST_OPTION)} alt='edit-icon' />
          ) : (
            THREE_D_TYPE
          )}
        </button>
        <button
          type='button'
          className={getSelectionOrNormalClass(SWITCH_VIEW_MODE.SECOND_OPTION)}
          onClick={() => buttonIsClicked(SWITCH_VIEW_MODE.SECOND_OPTION)}
        >
          {getIcon(SWITCH_VIEW_MODE.SECOND_OPTION) ? (
            <img
              src={getIcon(SWITCH_VIEW_MODE.SECOND_OPTION)}
              alt='visualize-icon'
            />
          ) : (
            TWO_D_TYPE
          )}
        </button>
      </MediaQuery>
    </div>
  );
};

export default dimensionTemplate;
